import { render } from "./TestimonialSlider.vue?vue&type=template&id=082b74ca&scoped=true"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"

import "./TestimonialSlider.vue?vue&type=style&index=0&id=082b74ca&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082b74ca"]])

export default __exports__